export const acknowledgedAtDateFormat = 'dd.MM.yyyy - HH:mm'

export const REF_SHIFT_LIST_DATE_PARAM_NAME = 'dateref'
